export const privacyCookieName = 'privacy_cookie';
export const performanceCookieName = 'performance_cookie';
export const advertisingCookieName = 'advertising_cookie';
export const functionalCookieName = 'functional_cookie';

export const canUseCookies = window?.$cookies?.get(privacyCookieName) || !locations.privacy_cookie_country;
